import { FormatEditor } from "@/components/FormatEditor";

const PLACEHOLDERS = [
  "company_name", "date", "undertaking_no",
  "logo_url", "signature_url",
  "customer_name", "customer_phone", "customer_email", "aadhaar", "pan",
  "address", "city", "tehsil", "pincode",
  "loan_type", "loan_amount", "sanction_amount",
  "lender_name", "lender_code", "lender_type", "lender_email",
  "partner_name", "sales_manager_name",
  "bank_application_no", "disbursement_no", "disbursed_amount",
  "rc_no", "note", "lead_id",
  "payout_bank_holder", "payout_bank_name", "payout_bank_account", "payout_bank_ifsc", "payout_bank_branch",
];

export default function UndertakingFormat() {
  return (
    <FormatEditor
      title="Lender Undertaking Format"
      desc="HTML template for the lender undertaking letter. Upload logo & signature below and reference them via {{logo_url}} and {{signature_url}} in the template."
      endpoint="/settings/undertaking-format"
      placeholders={PLACEHOLDERS}
      testId="undertaking-format-page"
      showLetterheadAssets
    />
  );
}
